import { useDispatch, useSelector } from "react-redux";
import { Button } from "src/components";
import { companyActions } from "src/context/company-slice";
import { RootState } from "src/context/store";
import AddEditCompany from "./add-edit-company-form.component";
import useGetCompanyList from "src/hooks/useGetCompanyList";
import Loader from "src/components/ui/loader.component";
import { useEffect } from "react";
import { queryPriceIdentifierCompany, userTypes } from "src/services/company-api";

const CompanyLayoutComponent = ({ children }: { children: React.ReactNode }) => {
  const { showAddEditForm } = useSelector((state: RootState) => state.company);
  const { data, loading, refetch, error } = useGetCompanyList();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      if (error) return;

      try {
        dispatch(companyActions.setCompanyMasterTable(data));

        const [priceResponse, userTypeResponse] = await Promise.all([
          queryPriceIdentifierCompany(),
          userTypes()
        ]);

        const priceData = priceResponse?.data?.data;
        const userTypeData = userTypeResponse?.data?.data;

        if (!Array.isArray(priceData)) {
          throw new Error("Invalid price identifier response");
        }

        const priceIdentifiers = priceData.map((item: any) => ({
          value: item.priceldentifier_id,
          label: item.description,
        }));

        const userTypesList = Array.isArray(userTypeData)
          ? userTypeData.map((item: any) => ({
            value: item.usertype,
            label: item.usertype,
          }))
          : [];

        dispatch(companyActions.setPriceIdentifier(priceIdentifiers));
        dispatch(companyActions.setUserType(userTypesList));
      } catch (err) {
        console.error("Error fetching company data:", err);
      }
    };

    fetchData();
  }, [data]);


  if (loading) return <Loader />;//M10-9403-Cluster

  return (
    <div className="w-full">
      {/* <SubHeader /> */}
      <section className="w-9/12 md:8/12">
        {showAddEditForm && <AddEditCompany refetch={refetch} setShowAddForm={(value: boolean) => dispatch(companyActions.setShowAddEditForm(value))} />}
      </section>
      <header className="flex items-center justify-between border-b-[1px] border-b-[#E9E9E9]">
        <div>
          {/* <Breadcrumb
            currentActive="Company"
            dataOrigin={[
              { name: "Masters", path: "masters" },
              { name: "Company", path: "company" },
            ]}
          /> */}
          <h1 className="text-[#49484C] font-bold text-[2rem]">Company</h1>
          <p className="text-[#767679] text-base mb-2">View and manage all your company configurations</p>
        </div>

        <div className="flex items-center gap-2 ">
          <Button
            onClick={() => {
              dispatch(companyActions.setShowAddEditForm(true));
              dispatch(companyActions.setIsEdit(false));
            }}
            className="bg-[#7F56D9] text-white h-11 w-[15rem]"
          >
            Add new
          </Button>
        </div>
      </header>
      {children}
    </div>
  );
};

export default CompanyLayoutComponent;
